import React, { useEffect, useState } from 'react';
import { AudioTrack, LocalAudioTrack } from 'twilio-video';
import { Progress } from '@chakra-ui/react';
import pollAudioLevel from './poll-audio';

interface Props {
  audioTrack?: AudioTrack;
}

const AudioLevelIndicator: React.FC<Props> = ({ audioTrack }: Props) => {
  const [audioLevel, setAudioLevel] = useState(0);

  useEffect(() => {
    if (audioTrack) {
      pollAudioLevel(audioTrack as LocalAudioTrack, (level: number) =>
        setAudioLevel(level)
      );
    }
  }, [audioTrack]);

  return <Progress value={audioLevel * 10} />;
};

export default AudioLevelIndicator;
